define('bizzabo/models/Answer',[
    'GSModel',
    'backbone-validation',
    'bizzabo/models/ValidationObject',
    'bizzabo/models/SyncedModel'
], function(
    GSModel,
    BackboneValidation,
    ValidationObject,
    SyncedModel
    ) {

    var Answer = SyncedModel.extend({

        defaults : {
        },

        sync : function(method, model, options) {
            if (method == 'delete') {
                // Leave this empty in order to support local destroy() calls
            }
        },

        initialize : function() {
            this.validationObject = new ValidationObject(this);
        },

        validation : {
            'text' : [
                {
                    required : true,
                    msg : 'Answer name is required'
                },
                {
                    maxLength : 250,
                    msg : 'Max. 250 characters'
                }
            ]
        }
    });

    return Answer;

});
